<template>
    <Popup
            v-model="popupShow"
            position="bottom"
            radius="5px"
            class="select-product-part-popup"
            @close="onCancel"
    >
        <div class="popup-bar">
            <div class="cancel" @click="onCancel">取消</div>
            <div class="title"> 选择配件</div>
            <div class="ok" @click="onOk">确定</div>
        </div>
        <div class="content">
            <List
                    style="height: 100%;margin-top:-5px;padding: 5px 12px"
                    :offset="50"
                    :immediate-check="true"
            >
                <div v-if="showAll"
                     @click="onSelect({id:null,name:'所有配件'})"
                     :class="{'product-part-item':true,'selected':!selected.id} ">
                    <div class="right">
                        <div class="title-small flex-center">所有配件</div>
                    </div>
                </div>
                <div v-for="(item, index) in parts" :key="index"
                     @click="onSelect(item)"
                     :class="{'part-item':true,'selected':selected.id==item.id,'flex-center-y':true}">
                    <img :src="getImgUrl(item.image)"/>
                    <div class="right">
                        <div class="title-small">{{item.name}}</div>
                        <div>{{item.model}}</div>
                    </div>
                </div>
            </List>
        </div>
    </Popup>
</template>

<script>
    import {List, Popup, Sticky} from "vant"
    import {downloadImg} from "@/config"

    export default {
        components: {
            Popup, List, Sticky
        },
        props: {
            show: {type: Boolean, default: false},
            parts: {type: Array, required: true},
            showAll: {type: Boolean, default: false},
            // defaultTitle: {type: String, default: '请选择产品'},
        },
        data() {
            return {
                selected: {}
            }
        },
        computed: {
            popupShow: {
                get() {
                    return this.show
                },
                set() {
                    this.onCancel()
                }
            },
            // title() {
            //     return (this.selected||{}).productName || this.defaultTitle
            // },
        },
        methods: {
            onCancel() {
                this.$emit('cancel')
            },
            onOk() {
                this.$emit('ok', this.selected)
            },
            getImgUrl(url) {
                return downloadImg + url
            },
            onSelect(product) {
                this.selected = product
                setTimeout(this.onOk, 120)
            }
        }
    };
</script>
<style lang="less" scoped>
    .select-product-part-popup {
        height: calc(100% - 140px);
        & > .content {
            display: flex;
            flex-direction: column;
            height: calc(100% - 50px);
            overflow-y: auto;
        }
    }

    .part-item {

        &.selected {
            border: 1px solid rgba(24, 144, 255, 1);
        }
        padding: 5px;
        display: flex;
        border-radius: 5px;
        border: 1px solid rgba(111, 111, 111, 0.3);
        margin-top: 2px;
        margin-bottom: 5px;
        & > img {
            height: 50px;
            width: 50px;
            margin: 5px;
        }
        & > .right {
            margin-left: 8px;
            line-height: 1.5;
        }
    }
</style>
